export default __webpack_public_path__ + "locales/zh-CN/DeleteDialog.json?hash=f15a3c363c17046632f20220a6bc00fb";